import { getCartToken } from "@faire/deprecated-retailer-visitor-shared/serialized-data/getCartToken";
import { QueryParameters as FaireSourceSummaryQueryParameters } from "@faire/web-api--source/endpoints/www/api/v2/carts/cartToken/fbf-benefits-cart/get";
import { useInvalidateQuery as useFaireSourceSummaryInvalidateQuery } from "@faire/web-api--source/endpoints/www/api/v2/carts/cartToken/fbf-benefits-cart/get-hooks";
import { useCallback } from "react";

export const useInvalidateFaireSourceSummary = () => {
  const invalidateCartQuery = useFaireSourceSummaryInvalidateQuery();

  const invalidateCartRequest = useCallback(async () => {
    const args = [
      getCartToken(),
      FaireSourceSummaryQueryParameters.build({}),
      undefined,
      { refetchType: "all" },
    ] as const;
    await Promise.all([invalidateCartQuery(...args)]);
  }, [invalidateCartQuery]);

  return invalidateCartRequest;
};
